module.exports = __webpack_public_path__ + "img/sowerbyc.ccb3a448.jpg";